module.exports = __webpack_public_path__ + "img/warning-o.9461c41c.svg";